import isEmpty from 'lodash.isempty';
import { InvalidParams } from '~shared/modules/error-handler';

export class ShoppingCartError extends Error {
  public static readonly COMMON_ERROR: unique symbol = Symbol('Shopping cart error::Identifier for common errors');
  public details = {};

  constructor (message: string, invalidParams: InvalidParams) {
    super (message);

    const defaultKey = ShoppingCartError.COMMON_ERROR;

    this.details = isEmpty(invalidParams)
      ? { [defaultKey]: { reason: defaultKey } }
      : invalidParams;
  }
}
